import type { FC } from 'react';

import classNames from 'classnames';

import type {
  AssetsApprovalBySchema,
  AssetsApprovalSchemaNullable,
} from '@iconik-io/iconik-api/src/services/assets';

import { useAppSelector } from '../../store/react_redux_typed';
import FailureStatuses from './statuses/failure_statuses';
import InfoStatuses from './statuses/info_statuses';
import SuccessStatuses from './statuses/success_statuses';

import styles from './asset_approval_status_detailed.module.css';

type ApprovalDetailedStatusIconProps = {
  approval?: AssetsApprovalSchemaNullable | null;
  expendedPod?: boolean;
  className?: string;
};

const getApprovals = (
  approval: AssetsApprovalSchemaNullable | null,
  userId: string,
) => {
  const approvedBy: AssetsApprovalBySchema[] = [];
  const rejectedBy: AssetsApprovalBySchema[] = [];
  const requestedBy: AssetsApprovalSchemaNullable[] = [];
  let rejectedByUser = false;
  let approvedByUser = false;
  let requestedByUser = false;

  if (!approval || approval.status === null) {
    return {
      approvedBy,
      rejectedBy,
      requestedBy,
      approvedByUser,
      requestedByUser,
      rejectedByUser,
    };
  }

  if (approval.status === 'REQUESTED') {
    requestedBy.push(approval);
    if (approval.requested_by === userId) {
      requestedByUser = true;
    }
  }

  if (approval.approvals_by && approval.approvals_by.length > 0) {
    approval.approvals_by.forEach((item) => {
      if (item.status === 'APPROVED') {
        approvedBy.push(item);
        if (item.user === userId) {
          approvedByUser = true;
        }
      }
      if (item.status === 'NOT_APPROVED') {
        rejectedBy.push(item);
        if (item.user === userId) {
          rejectedByUser = true;
        }
      }
    });
  }
  return {
    approvedBy,
    rejectedBy,
    requestedBy,
    approvedByUser,
    requestedByUser,
    rejectedByUser,
  };
};

const ApprovalDetailedStatusIcon: FC<ApprovalDetailedStatusIconProps> = ({
  approval,
  className,
}) => {
  const userId = useAppSelector((state) => state.authReducer.userData.id);
  if (!approval) {
    return null;
  }

  const {
    approvedBy,
    requestedBy,
    rejectedBy,
    requestedByUser,
    rejectedByUser,
    approvedByUser,
  } = getApprovals(approval, userId);

  return (
    <div className={classNames(styles.status_container, className)}>
      <FailureStatuses
        rejectedBy={rejectedBy}
        rejectedByUser={rejectedByUser}
      />
      <SuccessStatuses
        approvedBy={approvedBy}
        approvedByUser={approvedByUser}
      />
      <InfoStatuses
        requestedBy={requestedBy}
        requestedByUser={requestedByUser}
      />
    </div>
  );
};

export default ApprovalDetailedStatusIcon;
